// extracted by mini-css-extract-plugin
export default {"header":"styles_header__NyX8e","inner":"styles_inner__Tapoh","title":"styles_title__r3YGh","select":"styles_select__x+TQh"};